import React from 'react';
import {
  Paper,
  Typography,
  Box,
} from '@mui/material';

export {}; // Make this a module

interface Board {
  id: string;
  name: string;
  type: string;
  description: string;
  capacity: number;
  availabilitySettings: any;
  pricing: any;
  amenities?: string[];
  policies?: any;
  rules?: string;
  cancellationPolicy?: string;
}

interface QuickStatsProps {
  board: Board | null;
  reservationsCount: number;
}

const QuickStats: React.FC<QuickStatsProps> = ({ board, reservationsCount }) => {
  return (
    <Box sx={{ display: 'flex', gap: 3, mb: 3, flexWrap: 'wrap' }}>
      <Paper elevation={2} sx={{ p: 2, flex: 1, minWidth: 150, textAlign: 'center', bgcolor: 'info.light', color: 'white', borderRadius: 2 }}>
        <Typography variant="h4" fontWeight="bold">{reservationsCount}</Typography>
        <Typography variant="body2">Reservas Activas</Typography>
      </Paper>
      <Paper elevation={2} sx={{ p: 2, flex: 1, minWidth: 150, textAlign: 'center', bgcolor: 'success.light', color: 'white', borderRadius: 2 }}>
        <Typography variant="h4" fontWeight="bold">{board?.capacity || 0}</Typography>
        <Typography variant="body2">Capacidad Total</Typography>
      </Paper>
      <Paper elevation={2} sx={{ p: 2, flex: 1, minWidth: 150, textAlign: 'center', bgcolor: 'warning.light', color: 'white', borderRadius: 2 }}>
        <Typography variant="h4" fontWeight="bold">
          {board?.pricing?.basePrice ? `$${board.pricing.basePrice.toLocaleString()}` : 'N/A'}
        </Typography>
        <Typography variant="body2">Precio Base</Typography>
      </Paper>
    </Box>
  );
};

export default QuickStats;